// components
import { Spin } from "antd";
import { Loading3QuartersOutlined } from "@ant-design/icons";

// styles
import styles from "components/atoms/Spinner/spinner.module.css";
import theme from "styles/theme";

export const antIcon = <Loading3QuartersOutlined style={{ fontSize: 48, position: "fixed", top: "50%", color: theme.colors.violet }} spin />;

type SpinnerTypes = {
	type?: "transparent" | "full";
};

const Spinner = ({ type }: SpinnerTypes) => {
	const fullCls = type === "full" ? styles?.bg_full : "";
	const classes = type === "transparent" ? styles?.bg_transparent : fullCls;

	return (
		<div data-testid="loading-spinner" className={`${styles?.root} ${classes}`}>
			<Spin indicator={antIcon} />
		</div>
	);
};

export default Spinner;
